import React, {useState} from "react";
import styled from "styled-components";
import { Link } from 'gatsby';
import {StaticImage} from "gatsby-plugin-image";

const StyledHeader = styled.header`
  position:fixed;
  width: 100%;
  background: white;
  background: var(--background-color);
  z-index: 1000;
`;

const StyledNav = styled.nav`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;

  @media only screen and (min-width: 1025px ) {
    justify-content: space-around;
  }
`;

const LogoContainer = styled.div`
  display: flex;
  a{
    height: 2rem;
  }

  @media only screen and (min-width: 1025px ) {
    a{
      height: 3rem;
    }
  }
`;

const MobileMenuButton = styled.button`
    ${({isVisible})=>isVisible?'display:flex;':'display:none;'}
    background: transparent;
    padding: 0.5rem;
    border: none;

  @media only screen and (min-width: 1025px ) {
    display: none;
  }
`;

const MobileMenuIcon = styled.div`
  width: 24px;
  height: 3px;
  position: relative;
  background: var(--gold-highlight-color);
  &:before{
    position: absolute;
    width: 20px;
    height: 3px;
    content: " ";
    background: var(--gold-highlight-color);
    top:-7px;
    right:0;
  }
  &:after{
    position: absolute;
    width: 16px;
    height: 3px;
    content: " ";
    background: var(--gold-highlight-color);
    top:7px;
    right: 0;
  }
`;

const MobileMenuContainer = styled.div`
  flex-direction: column;
  background:var(--background-color);
  color: var(--primary-text-color);
  position: fixed;
  padding: 1.5rem;
  top: 0;
  bottom: 0;
  width: 100%;
  left: 100%;
  ${({isMenuOpened})=>isMenuOpened?'transform: translateX(-100%);':'transform: translateX(0%);'}  
  transition: transform 300ms cubic-bezier(0.4, 0, 0.2, 1) 0s;
  
  a {
    color: var(--primary-text-color);
    display: flex;
    align-items: center;
  }

  @media only screen and (min-width: 1025px ) {
    display: none;
  }
`;
const MobileMenuCloseButton = styled.button`
  display:flex;
  margin-left:auto;
  background: transparent;
  padding: 0.5rem;
  border: none;
`;

const MobileMenuCloseIcon = styled.div`
  display:block;
  width: 24px;
  height: 3px;
  position: relative;  
  background: var(--gold-highlight-color);
  transform: rotate(45deg);
  &:before{
    position: absolute;
    left: 0;
    width: 24px;
    height: 3px;
    content: " ";
    background: var(--gold-highlight-color);
    transform: rotate(90deg);
  }
`

const MobileMenuList = styled.ul`
  display: flex;
  flex-direction: column;
  list-style: none;
  margin-top: 40px;
`;

const MobileMenuListItem = styled.li`
  font-size: 1.2rem;
  margin-bottom: 20px;
`;

const DesktopMenuContainer = styled.div`
  display: none;

  @media only screen and (min-width: 1025px ) {
    display: inline-flex;
   
    a{
      color: var(--primary-text-color);
    }
    
    a:not(:first-of-type){
      margin-left: 45px;
    }
    
  }
`;


const Header = () => {
    const [menuOpened,toggleMenuOpened] = useState(false);
    return <StyledHeader>
        <StyledNav>
            <LogoContainer>
                <Link aria-label="Home" to="/"><StaticImage src="../assets/icons/going-shopping-icon.svg" alt="Going Shopping Logo"/></Link>
            </LogoContainer>
            <DesktopMenuContainer>
                <Link aria-label="Home" to="/">Home</Link>
                <Link aria-label="Feature Section" to="/#feature-section">Features</Link>
                <Link aria-label="Download Section" to="/#download-section">Download</Link>
                <Link aria-label="Blog Page" to="/blog/">Blog</Link>
            </DesktopMenuContainer>
            <MobileMenuButton aria-label="Open Menu Button" isVisible={!menuOpened} onClick={()=>toggleMenuOpened(true)}>
                <MobileMenuIcon></MobileMenuIcon>
            </MobileMenuButton>
            <MobileMenuContainer isMenuOpened={menuOpened}>
                <MobileMenuCloseButton aria-label="Close Menu Button" isVisible={menuOpened} onClick={()=>toggleMenuOpened(false)}>
                    <MobileMenuCloseIcon></MobileMenuCloseIcon>
                </MobileMenuCloseButton>
                <MobileMenuList>
                    <MobileMenuListItem><Link aria-label="Home" to="/" onClick={() => toggleMenuOpened(false)}><StaticImage src="../assets/icons/home-icon.svg" alt="" style={{maxWidth:"28px", marginRight:"10px"}}/>Home</Link></MobileMenuListItem>
                    <MobileMenuListItem><Link aria-label="Feature Section" to="/#feature-section" onClick={() => toggleMenuOpened(false)}><StaticImage src="../assets/icons/features-icon.svg" alt="" style={{maxWidth:"28px", marginRight:"10px"}}/>Features</Link></MobileMenuListItem>
                    <MobileMenuListItem><Link aria-label="Download Section" to="/#download-section" onClick={() => toggleMenuOpened(false)}><StaticImage src="../assets/icons/download-icon.svg" alt="" style={{maxWidth:"28px", marginRight:"10px"}}/>Download</Link></MobileMenuListItem>
                    <MobileMenuListItem><Link aria-label="Blog Page" to="/blog/" onClick={() => toggleMenuOpened(false)}><StaticImage src="../assets/icons/blog-icon.svg" alt="" style={{maxWidth:"28px", marginRight:"10px"}}/>Blog</Link></MobileMenuListItem>
                </MobileMenuList>
            </MobileMenuContainer>
        </StyledNav>
    </StyledHeader>
}

export default Header;